export default function Concept() {
  return (
    <section
      id="craftsmanship"
      className="relative w-full py-24 md:py-32 bg-background-100 border-t border-background-200/60"
    >
      <div className="w-full px-6 md:px-10 max-w-[1600px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* Left: heading */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-[2px] bg-primary-500"></span>
              <span
                className="text-primary-500 text-xs tracking-[0.4em]"
                style={{ fontFamily: "var(--font-label)" }}
              >
                CRAFTSMANSHIP
              </span>
            </div>
            <h4
              className="text-foreground-950 text-4xl md:text-6xl leading-[0.95] mb-6"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              <a
                href="#craftsmanship"
                className="hover:text-primary-500 transition-colors cursor-pointer"
              >
                従来では、
                <br />
                作れなかった<span className="text-primary-500">。</span>
              </a>
            </h4>
            <p className="text-foreground-700 text-base md:text-lg leading-relaxed max-w-md">
              金型では実現できない、複雑で軽量な内部構造。
              私たちは3Dプリント技術と流体解析、そしてアングラーの直感を融合させ、
              一投一投にすべてを注ぐアングラーのための道具を作り続けています。
            </p>
          </div>

          {/* Right: image + accent number */}
          <div className="lg:col-span-7 relative">
            <div className="relative w-full aspect-[4/3] overflow-hidden rounded-lg bg-background-200">
              <img
                src="https://static.readdy.ai/image/6598d90c230f37b72c6551167ff1d4d5/5da14f8e23637641ab5de922e116420d.jpeg"
                alt="島根の工房で3Dプリントされる雷撃カゴ"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-100/70 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                <div className="text-foreground-900 max-w-xs">
                  <div className="text-[10px] tracking-[0.4em] text-foreground-600 mb-1">
                    RESEARCH & DEVELOPMENT
                  </div>
                  <div className="text-sm md:text-base">
                    島根の工房で1層0.2mmずつ積み上げられる精密構造
                  </div>
                </div>
              </div>
            </div>

            {/* Big accent number */}
            <div className="absolute -top-6 -right-2 md:-right-6 flex flex-col items-end pointer-events-none">
              <div
                className="text-primary-500 text-6xl md:text-8xl leading-none"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                0.2
              </div>
              <div className="text-[10px] tracking-[0.3em] text-foreground-600 mt-1">
                MM PRECISION
              </div>
            </div>
          </div>
        </div>

        {/* AVG70M */}
        <div className="mt-20 border-t border-background-200/60 pt-12 flex flex-col items-center">
          <div
            className="text-primary-500 text-2xl md:text-4xl leading-none text-center"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            Average 70M OVER (close to 100 meters)
          </div>
          <div className="text-[10px] tracking-[0.4em] text-foreground-600 mt-2">
            BEYOND THE AVERAGE
          </div>
        </div>
      </div>
    </section>
  );
}